import { Component, OnInit, Injectable, ViewChild, Inject } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Subject } from 'rxjs/Subject';
import { MatPaginatorIntl } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { BackendService } from '../../core/backend.service';
import { UpdateEventService } from '../../shared-services/update-event.service';
import { MediaService } from '../../shared-services/media.service';
import { Subscription } from 'rxjs/Subscription';
import { SearchInputComponent } from '../../shared-components/search-input/search-input.component';

import { AbstractComponent } from '../../core/abstract-component';
import { NavigationService } from '../../shared-services/navigation.service';

import { EnvironmentProvider } from '../../core/browser-providers';
import { Environment } from '../../../environments/enviroment.model';

import { Acuerdo } from '../acuerdo.model';
import { ISelectedChip } from '../../cliente/cliente-filter.component';

enum ClienteEstadoLastLogin {
  ultimaSemana = 1,
  masUnaSemana = 2,
  masDosSemanas = 3
}

interface Filters {
  name: string;
  page: number;
  size: number;
  email: string;
  search?: string;
  sort?: string;
}

interface Page {
  pageIndex: number;
  pageSize: number;
}

@Component({
  selector: 'app-acuerdo-list',
  templateUrl: './acuerdo-list.component.html',
  styleUrls: ['./acuerdo-list.component.scss']
})
@Injectable()
export class AcuerdoListComponent extends AbstractComponent implements OnInit {
  selectedChips: ISelectedChip[] = [];
  private nameSearch = '';

  private filters: Filters = {
    name: undefined,
    email: undefined,
    page: 0,
    size: 50,
    sort: 'created,desc'
  };

  public showFilters = false;
  isMobile: boolean;

  @ViewChild(SearchInputComponent)
  private searchComponent: SearchInputComponent;

  private getNewPage = new Subject<Filters>();

  public totalItems: number;

  roleFiltersActive = false;
  mostrarResumen = false;
  isLoading = false;

  subscriptions: Subscription[] = [];

  acuerdosList = this.backendService.newSubjectWithoutDistinct<Filters>()
  .switchMap(filters => {
    const usersPromise = this.backendService.get(Acuerdo, Acuerdo.path, filters).toPromise();
    return (async () => {
      this.isLoading = true;
      try {
        const permissions = await usersPromise;
        return permissions;
      } catch (error) {
        return [];
      }
      finally {
        this.isLoading = false;
        this.roleFiltersActive = !(this.filters.search === '' || this.filters.search === undefined);
      }
    })();
  }).share() as Observer<Filters> & Observable<Acuerdo[]>;

  constructor(
    @Inject(EnvironmentProvider) env: Environment,
    protected route: ActivatedRoute,
    private backendService: BackendService,
    private paginatorsLabels: MatPaginatorIntl,
    protected router: Router,
    protected updateEventService: UpdateEventService,
    private mediaService: MediaService,
    protected navigation: NavigationService
  ) {
    super(navigation, route, router);
  }

  ngOnInit() {

    this.subscriptions.push(this.mediaService.isMobile.subscribe(isMobile => {
      this.isMobile = isMobile;
    }));

    this.paginatorsLabels.itemsPerPageLabel = 'Filas por página:';

    this.acuerdosList.subscribe(t => {
      this.isLoading = false;
      this.totalItems = t['totalItems'];
    });

    this.refresList();
  }

  refresList() {
    this.acuerdosList.next(this.getFilters());
  }

  getDefaultFilters() {
    this.filters = {
      name : undefined,
      email : undefined,
      page: 0,
      size: 50,
    };
  }

  getFilters() {
    return this.filters;
  }

  // Seteo de filtros
  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
    this.refresList();
  }

  async onSearch(searchText) {
    this.nameSearch = searchText;
    this.filters.search = await this.buildSearch(this.selectedChips);
    this.refresList();
  }

  async clearFilters() {
    this.searchComponent.searchBox.value = undefined;
    for (const chip of this.selectedChips) {
      chip.selectedChipFilterComponent.onRemoveChip();
    }
    this.selectedChips = [];
    this.filters.search = await this.buildSearch(this.selectedChips);
    this.refresList();
  }

  getData(response: Response) {
    const data = response.json();
    if (response.ok) { return data; }
    throw data['hydra:description'] || data['message'];
  }

  onAddAcuerdo() {
    this.router.navigate(['/acuerdos/agregar']);
  }

  displayFilters() {
    this.showFilters = !this.showFilters;
  }

  async onFiltersChanged(event) {
    this.selectedChips = event;
    this.filters.search = await this.buildSearch(this.selectedChips);
    this.refresList();
  }

  buildSearch(chips: ISelectedChip[]) {
    let searchString: string;
    searchString = this.buildSearchFilter(chips.filter(x => x.categoryName === 'Estado del acuerdo'), 'estado.id', false, ':');
    // searchString += this.buildSearchFilter(chips.filter(x => x.categoryName === 'Fecha de Acuerdo'), 'fechaDesde', false, '<');
    searchString += this.buildSearchFilter(chips.filter(x => x.categoryName === 'Fecha de Acuerdo'), 'fechaHasta', false, '>:');
    searchString += this.buildSearchFilter(chips.filter(x => x.categoryName === 'Fecha de Acuerdo'), 'fechaDesde', false, '<:');
   /*  searchString = this.buildSearchFilter(chips.filter(x => x.categoryName === 'Situación IVA'), 'situacionIva.id', false);
    searchString += this.buildSearchFilter(chips.filter(x => x.categoryName === 'Última conexión'), 'ultimoLogin', false, '#');
    searchString += this.buildSearchFilter(chips.filter(x => x.categoryName === 'Última compra'), 'ultimaCompra', false, '>');
    searchString += this.buildSearchFilter(chips.filter(x => x.categoryName === 'Fecha de última compra'), 'ultimaCompra', false, '>');
    searchString += this.buildSearchFilter(chips.filter(x => x.categoryName === 'Origen de Usuario'), 'origen', false);
    searchString += this.buildSearchFilter(chips.filter(x => x.categoryName === 'Provincias'), 'direcciones.provincia.id', false);
    searchString += this.buildSearchFilter(chips.filter(x => x.categoryName === 'Países'), 'direcciones.pais.id', false);
    searchString += this.buildSearchFilter(chips.filter(x => x.categoryName === 'Localidad'), 'direcciones.localidad', true); */
    if (this.nameSearch) {
      searchString += 'numero:' + this.nameSearch + ',';
    }

    return searchString;
  }

  // El nro de documento no debe ir entre corchetes para que pueda filtrar por 'like'
  buildSearchFilter(chips: ISelectedChip[], categoryName: string, filterLike: boolean, operator: string = ':') {
    if (chips.length > 0) {
      let search = filterLike ? categoryName + operator : categoryName + operator + '[';
      let flag = false;
      for (const chip of chips) {
        if (flag) {
          search += ',';
        }
        search += chip.tagId;
        flag = true;
      }
      return filterLike ? search += ',' : search += '],';
    }
    return '';
  }

  removeChip(event) {
    this.refresList();
  }

}



// WEBPACK FOOTER //
// ./src/app/acuerdo/acuerdo-list/acuerdo-list.component.ts